import { useMutation } from "@tanstack/react-query";
import { useFormik } from "formik";
import React, { useState } from "react";
import { Col, Container, Form, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { Link, useNavigate, useParams } from "react-router-dom";
import * as yup from "yup";
import Loader from "../components/Loader/Loader";
import { resetPassword } from "../services/services";
import { EyeIcon, HideIcon } from "../SvgIcons/allIcons";
import { toastAlert } from "../utils/SweetAlert";
import "./auth-responsive.css";
import "./auth.css";

const Resetpassword = () => {
  const { t } = useTranslation();
  const { id } = useParams();
  const navigate = useNavigate();
  const [showPass, setShowPass] = useState(false);
  const [showCnfPass, setShowCnfPass] = useState(false);
  const {
    values,
    errors,
    handleBlur,
    handleChange,
    touched,
    handleSubmit,
    resetForm,
  } = useFormik({
    initialValues: {
      password: "",
      cnfPassword: "",
    },
    validationSchema: yup.object().shape({
      password: yup
        .string()
        .required()
        .label(t("resetPassword.newPassword"))
        .matches(
          /(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[@$!%*#?&^_-]).{8,}/,
          t("resetPassword.strongPass")
        )
        .trim(),
      cnfPassword: yup
        .string()
        .required()
        .label(t("resetPassword.confirmPassword"))
        .oneOf([yup.ref("password"), null], t("resetPassword.passMustMatch")),
    }),
    onSubmit: (values) => {
      let body = {
        user_id: id,
        new_password: values?.password,
        confirm_password: values?.cnfPassword,
      };

      mutation.mutate(body);
    },
  });

  const mutation = useMutation({
    mutationFn: (body) => resetPassword(body),
    onSuccess: (resp) => {
      toastAlert("success", resp?.data?.message);
      resetForm();
      navigate("/");
    },
  });
  return (
    <section className="auth-main">
      <Container fluid className="p-0">
        <Row className="m-0 ">
          <Col lg={6} className="px-0">
            <div className="auth_img_wrp">
              <img src="/images/auth-img.png" alt="img" />
            </div>
          </Col>
          <Col lg={6}>
            
            <div className="auth-card">
              <div className="auth_logo">
                <Link to="/">
                  <img src="images/logo.svg" alt="" />{" "}
                </Link>
              </div>
              <div className="auth_heading">
                <h1>{t("resetPassword.resetPassword")}</h1>
                <p className="mb-0">{t("resetPassword.createNewPassword")}</p>
              </div>
              <Form>
                <Row>
                  <Col lg={12}>
                    <Form.Group className="mb-4 loginInput">
                      <label>{t("resetPassword.newPassword")}</label>
                      <div className="position-relative">
                        <img className="inputicon" src="/images/lock.svg"></img>
                        <Form.Control
                          type={showPass ? "text" : "password"}
                          placeholder={t("resetPassword.enterPassword")}
                          name="password"
                          value={values.password}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          autoComplete="current-password"
                          onKeyDown={(e) => {
                            if (e.key === "Enter") {
                              e.preventDefault();
                              handleSubmit();
                            }
                          }}
                        />
                        {showPass ? (
                          <span
                            className="eye-icon"
                            onClick={() => {
                              setShowPass(false);
                            }}
                          >
                            <EyeIcon />
                          </span>
                        ) : (
                          <span
                            className="eye-icon"
                            onClick={() => {
                              setShowPass(true);
                            }}
                          >
                            <HideIcon />
                          </span>
                        )}
                      </div>

                      <small className="text-danger">
                        {touched.password && errors.password}
                      </small>
                    </Form.Group>
                  </Col>
                  <Col lg={12}>
                    <Form.Group className="mb-4 position-relative eye_wrp loginInput">
                      <label>{t("resetPassword.confirmPassword")}</label>
                      <div className="position-relative">
                        <img className="inputicon" src="/images/lock.svg"></img>
                        <Form.Control
                          type={showCnfPass ? "text" : "password"}
                          placeholder={t("resetPassword.enterPassword")}
                          name="cnfPassword"
                          value={values.cnfPassword}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          autoComplete="current-password"
                          onKeyDown={(e) => {
                            if (e.key === "Enter") {
                              e.preventDefault();
                              handleSubmit();
                            }
                          }}
                        />
                        {showCnfPass ? (
                          <span
                            className="eye-icon"
                            onClick={() => {
                              setShowCnfPass(false);
                            }}
                          >
                            <EyeIcon />
                          </span>
                        ) : (
                          <span
                            className="eye-icon"
                            onClick={() => {
                              setShowCnfPass(true);
                            }}
                          >
                            <HideIcon />
                          </span>
                        )}
                      </div>
                      <small className="text-danger">
                        {touched.cnfPassword && errors.cnfPassword}
                      </small>
                    </Form.Group>
                  </Col>

                  <Col lg={12} className="text-end mt-3">
                    <button
                      type="button"
                      onClick={handleSubmit}
                      className="btn-theme "
                    >
                      {t("resetPassword.reset")}
                    </button>
                  </Col>
                </Row>
              </Form>
            </div>
          </Col>
        </Row>
      </Container>
      {mutation.isPending && <Loader />}
    </section>
  );
};

export default Resetpassword;
